(function () {
  var COOKIE = 'salut_attr';
  var MAX_AGE = 90 * 24 * 3600;
  var gtagEl = document.getElementById('salut-gtag');
  var gaId = gtagEl ? gtagEl.getAttribute('data-ga4-id') : '';
  var endpoint = (gtagEl ? gtagEl.getAttribute('data-conversions-endpoint') : '').replace(/\/$/, '');

  function readStore() {
    var match = document.cookie.match(/(?:^|; )salut_attr=([^;]*)/);
    if (!match) return {};
    try { return JSON.parse(decodeURIComponent(match[1])) || {}; } catch (e) { return {}; }
  }

  function writeStore(data) {
    document.cookie = COOKIE + '=' + encodeURIComponent(JSON.stringify(data)) + '; Max-Age=' + MAX_AGE + '; Path=/; SameSite=Lax; Secure';
  }

  function randomDigits(n) {
    var out = '';
    for (var i = 0; i < n; i++) out += Math.floor(Math.random() * 10);
    return out;
  }

  var GCLID_RE = /^[A-Za-z0-9_-]{10,300}$/;
  var FBCLID_RE = /^[A-Za-z0-9_-]{10,480}$/;

  function capture() {
    var store = readStore();
    var params = new URLSearchParams(window.location.search);
    var gclid = params.get('gclid');
    var fbclid = params.get('fbclid');
    if (gclid && GCLID_RE.test(gclid)) store.gclid = gclid;
    if (fbclid && FBCLID_RE.test(fbclid)) store.fbc = 'fb.1.' + Date.now() + '.' + fbclid;
    if (!store.fbp) store.fbp = 'fb.1.' + Date.now() + '.' + randomDigits(10);
    writeStore(store);
    return store;
  }

  var store = capture();

  function gtagValue(field) {
    return new Promise(function (resolve) {
      if (!gaId || typeof window.gtag !== 'function') return resolve('');
      var done = false;
      var timer = setTimeout(function () { if (!done) { done = true; resolve(''); } }, 800);
      window.gtag('get', gaId, field, function (value) {
        if (done) return;
        done = true;
        clearTimeout(timer);
        resolve(value ? String(value) : '');
      });
    });
  }

  function identifiers() {
    return Promise.all([gtagValue('client_id'), gtagValue('session_id')]).then(function (v) {
      var out = { user_agent: navigator.userAgent };
      if (v[0]) out.ga_client_id = v[0];
      if (v[1]) out.ga_session_id = v[1];
      if (store.gclid) out.gclid = store.gclid;
      if (store.fbc) out.fbc = store.fbc;
      if (store.fbp) out.fbp = store.fbp;
      return out;
    });
  }

  function post(path, body) {
    if (!endpoint) return Promise.resolve();
    var request = fetch(endpoint + path, {
      method: 'POST',
      headers: { 'Content-Type': 'text/plain;charset=UTF-8' },
      body: JSON.stringify(body),
      keepalive: true,
    }).catch(function () {});
    var timeout = new Promise(function (resolve) { setTimeout(resolve, 1500); });
    return Promise.race([request, timeout]).then(function () {});
  }

  var checkoutIds = null;

  function sendCheckoutEvent(path, prefix, data) {
    (checkoutIds || identifiers()).then(function (ids) {
      post(path, Object.assign({}, data, {
        eventId: prefix + Date.now().toString(36) + '-' + randomDigits(8),
        identifiers: ids,
      }));
    }).catch(function () {});
  }

  window.SalutAttribution = {
    identifiers: identifiers,
    report: function (key) {
      return new Promise(function (resolve) {
        var done = false;
        var timer = setTimeout(function () { if (!done) { done = true; resolve(); } }, 1500);
        identifiers()
          .then(function (ids) { return post('/api/attribution', Object.assign({}, key, { identifiers: ids })); })
          .catch(function () {})
          .then(function () { if (!done) { done = true; clearTimeout(timer); resolve(); } });
      });
    },
    prepareCheckout: function () {
      if (!checkoutIds) checkoutIds = identifiers();
    },
    checkoutStarted: function (data) {
      sendCheckoutEvent('/api/checkout-started', 'ic_', data);
    },
    paymentInfo: function (data) {
      sendCheckoutEvent('/api/payment-info', 'api_', data);
    },
  };
})();
